var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Header',{staticClass:"Header"},[_c('div',{staticClass:"global__wrapper"},[_c('div',{staticClass:"Header__h1",on:{"click":function () { return this$1.navigateTo('/'); }}},[_vm._v("\n      "+_vm._s(_vm.$prismic.richTextAsPlain(_vm.siteTitle))+"\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }